const TYPES = {
    LOGOUT: 'LOGOUT',
    CHECK_SIGNUP_REQUIREMENTS_MET: 'CHECK_SIGNUP_REQUIREMENTS_MET',
    CHECK_SIGNUP_REQUIREMENTS_MET_SUCCESS: 'CHECK_SIGNUP_REQUIREMENTS_MET_SUCCESS',
    CHECK_SIGNUP_REQUIREMENTS_MET_FAILED: 'CHECK_SIGNUP_REQUIREMENTS_MET_FAILED'
};

export default {
    TYPES,

    checkSignupRequirementsMet: () => ({
        type: TYPES.CHECK_SIGNUP_REQUIREMENTS_MET
    }),

    checkSignupRequirementsMetSuccess: (payload?) => ({
        type: TYPES.CHECK_SIGNUP_REQUIREMENTS_MET_SUCCESS,
        payload
    }),

    checkSignupRequirementsMetFailed: (error?) => ({
        type: TYPES.CHECK_SIGNUP_REQUIREMENTS_MET_FAILED,
        payload: {error}
    }),

    logoutEvent: () => ({
        type: TYPES.LOGOUT
    })
};
